var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeftOutline = function SvgArrowLeftOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M512 938.7c235.154 0 426.7-191.546 426.7-426.7S747.154 85.3 512 85.3 85.3 276.845 85.3 512c0 235.154 191.546 426.7 426.7 426.7m0-85.34c-189.033 0-341.36-152.328-341.36-341.36S322.967 170.64 512 170.64c189.032 0 341.36 152.327 341.36 341.36 0 189.032-152.328 341.36-341.36 341.36m-42.67-170.68V554.67h256.02v-85.34H469.33V341.32L298.65 512Z"
  })));
};
export default SvgArrowLeftOutline;